/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Status_UnmatchedInputs */

const cs_pm_status_unmatched = /** @type {(inputs: Pm_Status_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nespárováno`)
};

const en_pm_status_unmatched = /** @type {(inputs: Pm_Status_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmatched`)
};

/**
* | output |
* | --- |
* | "Unmatched" |
*
* @param {Pm_Status_UnmatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_status_unmatched = /** @type {((inputs?: Pm_Status_UnmatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Status_UnmatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_status_unmatched(inputs)
	return cs_pm_status_unmatched(inputs)
});